/**
 * Created by Ning Jiang on 2022-06-14.
 */

import {GuiButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/GuiButton";
import {gsap} from "gsap";
import {SerialSound} from "../../sound/SerialSound";
import {Serial} from "../../Serial";
import {PointerState} from "@nolimitcity/slot-launcher/bin/gui/buttons/states/PointerState";

export class PickButton extends GuiButton {

    private _glowTween:TweenMax | null;

    private _buttonConfig = [
        [
            {
                x : 231, y : 517,
                anchorX : 0.5, anchorY : 0.5,
                texture : "wincap/L1_Buttons/L1_tent1",
                glowX : 0, glowY : 0,
                glowScale : 2,
                glowTexture : "wincap/wincap1/L1_buttons/01",
                numberX : -10, numberY : -102,
                hitArea : new PIXI.Rectangle(-105, -60, 210, 120)
            },
            {
                x : 531, y : 526,
                anchorX : 0.5, anchorY : 0.5,
                texture : "wincap/L1_Buttons/L1_tent2",
                glowX : 0, glowY : 0,
                glowScale : 2,
                glowTexture : "wincap/wincap1/L1_buttons/02",
                numberX : -6, numberY : -102,
                hitArea : new PIXI.Rectangle(-90, -50, 180, 90)
            }
        ],
        [
            {
                x : 143, y : 363,
                anchorX : 0, anchorY : 0.5,
                texture : "wincap/buttons/doorAboveL",
                glowX : 0, glowY : 0,
                glowScale : 1,
                glowTexture : "wincap/buttons/doorLeft",
                numberX : 36, numberY : -66,
                hitArea : new PIXI.Rectangle(0, -190, 130, 380)
            },
            {
                x : 576, y : 364,
                anchorX : 1, anchorY : 0.5,
                texture : "wincap/buttons/doorAboveR",
                glowX : 0, glowY : 0,
                glowScale : 1,
                glowTexture : "wincap/buttons/doorRight",
                numberX : -36, numberY : -66,
                hitArea : new PIXI.Rectangle(-114, -190, 114, 380)
            }
        ],
        [
            {
                x : 313, y : 382,
                anchorX : 0.5, anchorY : 0.5,
                texture : "wincap/L3_buttons/L2_wc1",
                glowX : 0, glowY : 0,
                glowScale : 1,
                glowTexture : "wincap/wincap3/L2_glow2",
                numberX : -8, numberY : -120,
                hitArea : new PIXI.Rectangle(-60, -76, 120, 152)
            },
            {
                x : 488, y : 382,
                anchorX : 0.5, anchorY : 0.5,
                texture : "wincap/L3_buttons/L2_wc2",
                glowX : 0, glowY : 0,
                glowScale : 1,
                glowTexture : "wincap/wincap3/L2_glow",
                numberX : -6, numberY : -120,
                hitArea : new PIXI.Rectangle(-66, -84, 132, 168)
            }
        ]
    ];

    private _image:PIXI.Sprite;
    private _glow:PIXI.Sprite;
    private _number:PIXI.Sprite;
    private _indexCallback:null | (() => void);

    constructor(level:number, index:number) {
        super(`${level}-${index + 1}`);

        const config = this._buttonConfig[level][index];

        this._glow = new PIXI.Sprite(Serial.assetLoader.getTextures(config.glowTexture)[0]);
        this._glow.anchor.set(config.anchorX, config.anchorY);
        this._glow.scale.set(config.glowScale);
        this._glow.position.set(config.glowX, config.glowY);
        this._glow.blendMode = PIXI.BLEND_MODES.ADD;
        this.addChild(this._glow);

        this._image = new PIXI.Sprite(Serial.assetLoader.getTextures(config.texture)[0]);
        this._image.anchor.set(config.anchorX, config.anchorY);
        this.addChild(this._image);

        this._number = new PIXI.Sprite(Serial.assetLoader.getTextures(`wincap/L1_Buttons/L1_${index + 1}`)[0]);
        this._number.anchor.set(0.5);
        this._number.position.set(config.numberX, config.numberY);
        this.addChild(this._number);

        this.hitArea = config.hitArea;

        // const tempRect = new PIXI.Graphics();
        // tempRect.beginFill(0xFF0000, 0.5);
        // tempRect.drawRect(config.hitArea.x, config.hitArea.y, config.hitArea.width, config.hitArea.height);
        // tempRect.endFill();
        // this.addChild(tempRect);

        this.position.set(config.x, config.y);
        this.enable(false);
        this.visible = false;
        this.debug = true;

        this.addClickCallback(() => {
            // play view
            if(this._indexCallback) {
                this._indexCallback();
                this._indexCallback = null;
            }
        });
    }

    public addIndexCallback(callback:() => void) {
        this._indexCallback = callback;
    }

    public playClick(replay:boolean):TimelineLite {
        for(let i = 0; i < 3; i++) {
            SerialSound.PLAYING_LOOP_EFFECT = "";
            SerialSound.soundPlayer.stopTrack(SerialSound.WIN_CAP_LOOP[i]);
        }
        SerialSound.soundPlayer.playTrack({name : SerialSound.WIN_CAP_CLICK});
        this.showAsNormal();
        const glowScale = this._glow.scale.x;
        const tl = gsap.timeline();
        tl.add(() => {this.reset()});
        if(replay) {
            tl.add([
                gsap.to(this._image.scale, {x : 1.1, y : 1.1, duration : 0.1}),
                gsap.to(this._glow.scale, {x : glowScale * 1.1, y : glowScale * 1.1, duration : 0.1})
            ]);
            tl.add([
                gsap.to(this._image.scale, {x : 1, y : 1, duration : 0.1}),
                gsap.to(this._glow.scale, {x : glowScale, y : glowScale, duration : 0.1})
            ]);
            tl.add([
                gsap.to(this._image.scale, {x : 1.1, y : 1.1, duration : 0.1}),
                gsap.to(this._glow.scale, {x : glowScale * 1.1, y : glowScale * 1.1, duration : 0.1})
            ]);
            tl.add([
                gsap.to(this._image.scale, {x : 1, y : 1, duration : 0.1}),
                gsap.to(this._glow.scale, {x : glowScale, y : glowScale, duration : 0.1})
            ]);
        }
        tl.add([
            gsap.to(this._image.scale, {x : 1.2, y : 1.2, duration : 0.1}),
            gsap.to(this._glow.scale, {x : glowScale * 1.3, y : glowScale * 1.3, duration : 0.4}),
            gsap.fromTo(this._glow, {alpha : 1}, {alpha : 0, duration : 0.3, delay : 0.1})
        ]);
        return tl;
    }

    public showAsNormal():void {
        this.onPointerStateUpdate(PointerState.IDLE);
    }

    protected onPointerStateUpdate(state:PointerState) {
        this.reset();
        switch(state) {
            case  PointerState.IDLE:
                this._glowTween = gsap.fromTo(this._glow,
                    {alpha : 0.3},
                    {duration : 1, alpha : 0.8, yoyo : true, repeat : -1}
                );
                break;
            case PointerState.OVER:
            case PointerState.DOWN:
                this._glowTween = gsap.fromTo(this._glow,
                    {alpha : 0.3},
                    {duration : 0.5, alpha : 1, yoyo : true, repeat : -1}
                );
                break;
            case PointerState.DISABLED:
                this._image.tint = 0x555555;
                this._number.tint = 0x555555;
                this._glow.visible = false;
        }
    }

    private reset():void {
        if(this._glowTween) {
            this._glowTween.kill();
        }
        this._image.tint = 0xFFFFFF;
        this._number.tint = 0xFFFFFF;
        this._glow.visible = true;
    }
}